import { render } from "./UpsellSalesCart.vue?vue&type=template&id=4d4f3f4e"
import script from "./UpsellSalesCart.vue?vue&type=script&lang=js"
export * from "./UpsellSalesCart.vue?vue&type=script&lang=js"

import "./UpsellSalesCart.vue?vue&type=style&index=0&id=4d4f3f4e&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__